// extracted by mini-css-extract-plugin
module.exports = {"noGames":"_chtw4nC","modal":"_195LNR-","pageNotFoundText":"_2O9MPHl","returnToMainPage":"_33Mr8HD","oopsMessage":"_38IJV96","infoBackground":"_2W8IjOv"};